<div class="wrapper-modal wrapper-modal-custom-reservation-calendar">
  <div class="wrapper-content-modal">
    <form [formGroup]="workingDateForm" (ngSubmit)="onSubmit()" class="wrapper-open-day">
      <div class="title-day">
        <span class="day">{{selectedDayName}}</span>
        <span>{{selectedDateKey | date: 'dd.MM.yyyy'}}</span>
      </div>
      <div class="wrapper-checkbox-custom">
        <div>
          <input class="checkbox-custom" type="checkbox" id="checkbox14" formControlName="work">
          <label class="checkbox-custom-label" for="checkbox14">Igraonica je otvorena</label>
        </div>
      </div>
      <div class="terms-title xs-mt-32">Termini</div>
      <div class="wrapper-time-terms">
        <div class="time-term free">
          <span>Slobodni</span>
        </div>
        <div class="time-term busy">
          <span>Zauzeti</span>
        </div>
      </div>
      <div class="wrapper-time-terms">
        <div *ngFor="let term of selectedTermsDate" (click)="showTimeslots(term)" class="time-term" [ngClass]="{'free': !areAllSlotsDisabled(term), 'active': term.start_time === isShowTimeslot?.start_time, 'busy': areAllSlotsDisabled(term)}">
          <span>{{term.start_time | slice: 0: -3}} - {{term.end_time | slice: 0: -3}}</span>
        </div>
      </div>
      <div class="wrapper-calendar-slot-reservations">
        <div *ngIf="isShowTimeslot">
          <div class="wrapper-calendar-slot-reservation" *ngFor="let timeslot of isShowTimeslot?.slots" (click)="selectTimeslot(timeslot, isShowTimeslot)" [ngClass]="timeslot.is_disabled ? 'disabled' : 'free'">
            <div class="wrapper-item-slot-reservation">
              <span>Opis: </span>
              <span class="value">{{timeslot?.description}}</span>
            </div>
            <div class="wrapper-item-slot-reservation">
              <span>Cena:</span>
              <span class="value">{{timeslot?.price}}</span>
            </div>
            <div class="wrapper-item-slot-reservation">
              <span>Početak termina:</span>
              <span class="value">{{timeslot?.start_time}}</span>
            </div>
            <div class="wrapper-item-slot-reservation">
              <span>Kraj termina:</span>
              <span class="value">{{timeslot?.end_time}}</span>
            </div>
            <div class="wrapper-item-slot-reservation">
              <span>Rezervisano slotova:</span>
              <span class="value">{{timeslot?.booked_count}}</span>
            </div>
            <div class="wrapper-item-slot-reservation">
              <span>Ukupno slotova za rezervaciju:</span>
              <span class="value">{{timeslot?.max_bookings}}</span>
            </div>
            <div class="wrapper-calendar-slot-reserved" *ngIf="isSlotSelected && selectedSlot.slot_id === timeslot.slot_id">
              <div *ngFor="let booking of selectedSlot.bookings">
                <div>
                  <div class="content-reservation">
                    <div class="wrapper-celebrants">
                      <span *ngFor="let celebrant of booking?.company_reservation?.reservation.celebrators" class="celebrants">{{celebrant.name}} ({{(celebrant.birthday | returnAgeOfCelebrant)+ 1}}), </span>
                    </div>
                    <div *ngIf="booking?.company_reservation?.business_category_id !== 1 && booking?.company_reservation?.reservation.delivery_address" class="wrapper-address">
                      <span class="label-address">Dostava na adresu:</span>
                      <span class="address-reservation">{{booking?.company_reservation?.reservation.delivery_address}}</span>
                    </div>
                    <div class="wrapper-info-customer">
                      <h4>Podaci o kupcu</h4>
                      <p>Ime i prezime: <span>{{booking?.company_reservation?.reservation?.user?.full_name}}</span></p>
                      <p>Grad: <span>{{booking?.company_reservation?.reservation?.user?.city?.name}}</span></p>
                      <p>Broj telefona: <span>{{booking?.company_reservation?.reservation?.user?.phone}}</span></p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
<!--        <div class="price-total">-->
<!--          <span class="label">Cena</span>-->
<!--          <span class="value">50.000 RSD</span>-->
<!--        </div>-->
      <div class="wrapper-btn-open-day">
        <button class="zc-btn zc-btn--gray" type="button" (click)="closeModal.emit()"><span>OTKAŽI</span></button>
        <button
          type="submit"
          [disabled]="initialWorkState === workingDateForm.controls.work.value"
          class="zc-btn zc-btn--primary"
          [ngClass]="{'not-allowed': initialWorkState === workingDateForm.controls.work.value}"><span>POTVRDI IZMENE</span>
        </button>
      </div>
    </form>
  </div>
</div>
